<template>
  <div class="home">
    <div class="swiper" style="position:relative;">
      <div style="color:red;position:absolute;top:0;left:20px;">{{expireWarn}}</div>
      <van-swipe
        class="my-swipe"
        :autoplay="3000"
        width="100%"
        indicator-color="white"
      >
        <van-swipe-item>
          <img src="@/assets/img/home/banner.jpg" alt="" />
        </van-swipe-item>
        <!-- <van-swipe-item>2</van-swipe-item>
        <van-swipe-item>3</van-swipe-item>
        <van-swipe-item>4</van-swipe-item> -->
      </van-swipe>
    </div>
    <div class="mainBox">
      <div class="gridBox">
        <div class="title">应用</div>
        <div class="gridItemBox">
          <div class="gridItem" @click="goTo('/invoiceClip')">
            <div class="iconImg">
              <img src="@/assets/img/fpj.png" alt="" />
            </div>
            <div class="text">发票夹</div>
          </div>
          <div class="gridItem" @click="goTo('/jobNavigation')">
            <div class="iconImg"><img src="@/assets/img/dh.png" alt="" /></div>
            <div class="text">工作流导航</div>
          </div>
          <div class="gridItem" @click="goTo('/setting')">
            <div class="icon">
              <!-- <svg-icon icon-class="setting1" style="font-size:0.7rem;"></svg-icon> -->
              <van-icon name="setting"/>
            </div>
            <div class="text">设置</div>
          </div>
        </div>
      </div>
      <div class="gridBox">
        <div class="title">我的事项</div>
        <div class="gridItemBox">
          <div class="gridItem" @click="goTo('/myRequest')">
            <div class="num">{{ num.applyCount }}</div>
            <div class="text">我的请求</div>
          </div>
          <div
            class="gridItem"
            @click="goTo('/myBacklog')"
            v-if="num.todoCount >= 0"
          >
            <div class="num">{{ num.todoCount }}</div>
            <div class="text">共享审核</div>
          </div>
          <div class="gridItem" @click="goTo('/myHaveDone')">
            <div class="num">{{ num.haveTodoCount }}</div>
            <div class="text">我的已办</div>
          </div>
        </div>
        <div class="gridItemBox">
          <div
            class="gridItem"
            @click="goTo('/receiptApproval')"
            v-if="num.sdCount >= 0"
          >
            <div class="num">{{ num.sdCount }}</div>
            <div class="text">属地审核</div>
          </div>
          <div class="gridItem" @click="goTo('/wxTest')" v-if="mobile === '18818198556' || mobile === '18721213462' || mobile === '18635946042'">
            <div class="text">微信测试</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Cookies from "js-cookie";
export default {
  created() {
    if (this.token) {
      this.getData();
    }
    // this.getData();
  },
  computed: {
    ...mapState(["token","expireWarn"]),
  },
  watch: {
    token(newval) {
      console.log(newval);
      if (newval) {
        this.getData();
      }
    },
  },
  data() {
    return {

      num: {
        applyCount: 0, //请求数量
        haveTodoCount: 0, //已办数量
        todoCount: 0, //待办数量
        sdCount: 0, //收单数量
      },
      mobile: ''
    };
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    },
    getData() {
      this.mobile = JSON.parse(Cookies.get("payapp_userInfo")).mobile;
      this.$api
        .post("/payment/center/reimburse/statistical", {
          reqData: {},
        })
        .then((res) => {
          if (res.repCode == "0000") {
            this.num = res.repData;
          }
        });
    },
  },
};
</script>

<style lang="scss">
// .home {
//   height: 100%;
// //   font-size: 12px;
// //   padding: 0 10px ;
//   .swiper {
//     padding: 20px 10px;
//     border-radius: 10px;
//     overflow: hidden;
//   }
//   .my-swipe{
//     width: 100%;
//     box-shadow: 0px 10px 10px 0 rgb(189, 197, 241);
//     border-radius: 10px;
//   }
//   .my-swipe .van-swipe-item {
//     color: #fff;
//     font-size: 20px;
//     line-height: 150px;
//     text-align: center;
//     background-color: #39a9ed;
//     border-radius: 10px;
//   }
//   .mainBox{
//     padding: 0 10px;
//     .gridBox{
//         background: #fff;
//         margin-bottom: 10px;
//         padding: 10px;
//         .title{
//             color: rgb(158, 158, 158);
//         }
//         .gridItemBox{
//             display: flex;
//             margin-top: 10px;
//             height: 80px;
//             .gridItem{
//                 // padding: 10px 0;
//                 flex: 1;
//                 display: flex;
//                 flex-direction: column;
//                 align-items: center;
//                 justify-content: center;
//                 cursor: pointer;
//                 .icon{
//                     font-size: 0px;
//                     img{
//                         width: 30px;
//                         height: 30px;
//                         display: block;
//                     }
//                 }
//                 .num{
//                     font-size: 30px;
//                 }
//                 .text{
//                     margin-top: 10px;
//                     color:rgb(100, 100, 100);
//                 }
//             }
//         }
//     }
//   }
// }
</style>